import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { NikoPatientInformationBarForm } from 'application/niko-patient/forms';
import { NikoPatientService } from "application/niko-patient/services";
import { action, observable } from "mobx";
import { ModalParams } from 'core/models';
import { getErrorMessage } from "core/utils";
class NikoPatientInformationBarViewStore extends BaseEditViewStore {
    @observable accessor isEditMode = false;
    @observable accessor isStatusBarVisible = false;
    constructor(rootStore, componentProps) {
        const nikoPatientService = new NikoPatientService(rootStore.application.baasic.apiClient);
        const nikoPatient = componentProps.nikoPatient;
        super(rootStore, {
            name: 'niko-patient-information-bar',
            id: nikoPatient.id,
            Form: NikoPatientInformationBarForm,
            actions: () => {
                return {
                    get: () => {
                        return nikoPatient;
                    },
                    update: async (resource) => {
                        await nikoPatientService.updatePatientInformation(resource);
                    }
                }
            },
            FormClass: NikoPatientInformationBarForm,
        });

        this.rootStore = rootStore;
        this.nikoPatient = componentProps.nikoPatient;
        this.oldNikoPatient = { ...componentProps.nikoPatient };
        this.nikoHealthBaseUrl = rootStore.applicationStore.app.baasic.settings.nikoHealthBaseUrl;
        this.showVisibilityOption = componentProps.showVisibilityOption;
        this.disableEditMode = Boolean(componentProps.disableEditMode);

        this.genderStore = new BaasicDropdownStore({
            textField: 'name',
            dataItemKey: 'name'
        }, {
            fetchFunc: () => {
                return [{ name: 'Female' }, { name: 'Male' }];
            }
        });

        this.facilityOrderNewFlowConfirmModal = new ModalParams({});
    }

    @action.bound
    goToNikoHealth() {
        window.open(`${this.nikoHealthBaseUrl}v2/#/patients/${this.nikoPatient.remoteId}/demographics`);
    }

    @action.bound
    changeEditMode(isCancel = false) {
        this.isEditMode = !this.isEditMode;
        if (isCancel) {
            this.form.$("firstName").value = this.oldNikoPatient.firstName;
            this.form.$("lastName").value = this.oldNikoPatient.lastName;
            this.form.$("gender").value = this.oldNikoPatient.gender;
            this.form.$("ssn").value = this.oldNikoPatient.ssn;
            this.form.$("dateOfBirth").value = this.oldNikoPatient.dateOfBirth;
        }
    }

    @action.bound
    isFormValidate() {
        var result = true;
        if (this.form.$("firstName").value == "" || this.form.$("lastName").value == "") {
            this.rootStore.notificationStore.error('Patient first and last name cannot be empty.');
            result = false;
        }

        let regex = /^\d{9}$/;
        if (this.form.$("ssn").value != "" && !regex.test(this.form.$("ssn").value)) {
            this.rootStore.notificationStore.error('SSN must contain 9 digits.');
            result = false;
        }

        regex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/(18|19|20)\d{2}$/;
        if (this.form.$("dateOfBirth").value == "" || !regex.test(this.form.$("dateOfBirth").value)) {
            this.rootStore.notificationStore.error('DOB format must be mm/dd/yyyy.');
            result = false;
        }
        return result;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update || !this.isFormValidate()) return;

        await this.facilityOrderNewFlowConfirmModal.open({
            onConfirm: async () => await this.saveResource(resource),
            message: "Changes made to patient info will be inputted to Niko. Please confirm all information is accurate before proceeding."
        });
    }

    @action.bound
    async saveResource(resource) {
        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.nikoPatient.id,
                ...resource
            });

            this.oldNikoPatient.firstName = this.form.$("firstName").value;
            this.oldNikoPatient.lastName = this.form.$("lastName").value;
            this.oldNikoPatient.gender = this.form.$("gender").value;
            this.oldNikoPatient.ssn = this.form.$("ssn").value;
            this.oldNikoPatient.dateOfBirth = this.form.$("dateOfBirth").value;

            this.nikoPatient.firstName = this.form.$("firstName").value;
            this.nikoPatient.lastName = this.form.$("lastName").value;
        }
        catch (err) {
            return this.onUpdateError(err);
        }
        finally {
            this.form.setFieldsDisabled(false);
            this.changeEditMode();
        }
    }

    onUpdateError(err) {
        this.rootStore.notificationStore.error(getErrorMessage(err, 'Error occurred while trying to update a Niko Patient information.'));
    }

    @action.bound
    changeMenuVisibility() {
        this.isStatusBarVisible = !this.isStatusBarVisible;
        // if (!this.isStatusBarVisible)
        //     this.isEditMode = false;
        // if (this.isStatusBarVisible)
        //     this.isEditOptionDisabled = this.getDisabledRules();
    }
}

export default NikoPatientInformationBarViewStore;
